import script from "./Total.vue?vue&type=script&setup=true&lang=js"
export * from "./Total.vue?vue&type=script&setup=true&lang=js"

import "./Total.vue?vue&type=style&index=0&id=49473995&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49473995"]])

export default __exports__